<template>
  <div id="contenedor-main-listado-programas-obra">
    <template>
      <desktop :programa="programa" :solo-lectura="soloLectura"></desktop>
    </template>
    <!-- <template v-else>
      <desktop :programa="programa" :solo-lectura="soloLectura"></desktop>
    </template> -->
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoProgramasObra',
  props: {
    programa: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
